var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93917 12.6465L7.69193 11.8975L7.69192 11.8975L7.69192 11.8975C5.33871 11.1131 4.16211 10.7209 4.16211 10.0001C4.16211 9.27934 5.33872 8.88713 7.69193 8.10273L16.2051 5.26501C17.8609 4.71308 18.6888 4.43711 19.1258 4.87413C19.5628 5.31114 19.2869 6.13904 18.7349 7.79483L15.8972 16.308L15.8972 16.308L15.8972 16.308C15.1128 18.6612 14.7206 19.8378 13.9998 19.8378C13.2791 19.8378 12.8869 18.6612 12.1025 16.308L11.3534 14.0608L15.7069 9.7072C16.0975 9.31668 16.0975 8.68351 15.7069 8.29299C15.3164 7.90247 14.6832 7.90247 14.2927 8.29299L9.93917 12.6465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3abb57ab26b374e43ba5226a18e58542.svg";
export { ForwardRef as ReactComponent };